import { RootState } from "app/store";

const selectSessionId = (state: RootState) => state.diagnostics.sessionId;

export const diagnosticsSessionSelectors = {
    selectSessionId,
};
